import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'
import base from './common/base.css'
import axios from 'axios'
import './assets/base.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Sortable from 'sortablejs'

// 简单配置
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })


router.beforeEach((to,from,next) => {
  NProgress.start()
  next()
});

router.afterEach(() => {
  NProgress.done()
});

var root = process.env.BASE_API;
//请求拦截
axios.interceptors.request.use((config) => {
    //请求之前重新拼装url
    config.url = root + config.url;
    return config;
});
Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
axios.defaults.baseURL = '/api';


Vue.use(Element, { size: 'small', zIndex: 3000 });
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  render: h => h(App)
  // components:{
  //   'my-app':App
  // }
})



// WEBPACK FOOTER //
// ./src/main.js